import { render, staticRenderFns } from "./SetIpModel.vue?vue&type=template&id=f66ba38c&scoped=true&"
import script from "./SetIpModel.vue?vue&type=script&lang=js&"
export * from "./SetIpModel.vue?vue&type=script&lang=js&"
import style0 from "./SetIpModel.vue?vue&type=style&index=0&id=f66ba38c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66ba38c",
  null
  
)

export default component.exports